import React from 'react'
import { Grid, Typography } from '@mui/material'
import Image from 'next/image'
import useStyles from './Styles'
import { Box } from '@mui/system'
import Avatar from '@mui/material/Avatar'
import Link from 'next/link'
import { campaignCardsI } from 'src/types/store/index'
// import { formatDate } from 'src/utils/strapiDateFormatter'
import LinkIcon from 'src/assets/svgs/campaigns/LinkIcon.svg'
import { getCookie } from 'cookies-next'
// import { useRouter } from 'next/router'
interface Props {
  cardsData: campaignCardsI[]
  zenMode: boolean
}

function Card({ cardsData, zenMode }: Props) {
  const { classes } = useStyles()
  const isBrowser = typeof window === 'object' ? true : false
  const lang = getCookie('lang')
  // const router = useRouter()
  return (
    <div>
      <Typography className={classes.header}>
        {isBrowser && lang === 'En' ? 'campaigns' : 'Campañas'}
      </Typography>
      <Typography className={classes.desc}>
        {isBrowser && lang === 'En'
          ? ' New launches from Ditch the Label and our partners.'
          : 'Nuevos lanzamientos de Quítate las Etiquetas y de nuestros socios.'}
      </Typography>

      <Grid
        container
        spacing={{ md: 10, sm: 8, xs: 0 }}
        rowSpacing={{ md: 16, sm: 10, xs: 10 }}
        my={8}
      >
        {cardsData.map((card, idx) => {
          return (
            <Grid item xs={12} sm={6} md={6} key={idx}>
              {!zenMode && (
                <a href={card.link}>
                  <Image
                    src={`${card?.image?.data?.attributes?.url}`}
                    alt="image"
                    className={classes.imgCard}
                    width={662}
                    height={361}
                    // onClick={() => router.push(card.link)}
                  />
                </a>
              )}

              {/* <Typography className={classes.date}>
                {formatDate(card.date)}
              </Typography> */}
              <Box className={classes.linkTitle}>
                <Typography className={classes.title}>
                  {card.heading}
                </Typography>
                {card.link && card.link !== '#' ? (
                  <Link href={card.link} aria-label="link">
                    <Image
                      src={LinkIcon}
                      alt="image"
                      className={classes.img}
                      aria-label="Link button"
                    />
                  </Link>
                ) : null}
              </Box>

              <Box className={classes.brandInfo}>
                <Avatar
                  className={classes.avatar}
                  src={` ${card?.brandAvatar?.data?.attributes?.url}`}
                ></Avatar>
                <Box>
                  <Typography className={classes.partners} pl={4}>
                    {' '}
                    Partners
                  </Typography>
                  <Typography className={classes.name} pl={4}>
                    {' '}
                    {card.brandName}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}

export default Card
